const APPLE_REGEX = /Mac|iPod|iPhone|iPad/;
function isApple() {
  return typeof window !== "undefined" && APPLE_REGEX.test(window.navigator.platform);
}

export { isApple };
//# sourceMappingURL=is-apple.js.map
